export default "__VITE_ASSET__hYU$xaxC__"